export const listHoverHandler = (sectionId, status) => {
  const tableItem = document.querySelector(`.ant-table-row[data-row-key="${sectionId}"]`);
  if (status) {
    tableItem?.classList?.add("hover");
  } else {
    tableItem?.classList?.remove("hover");
  }
};
